import { useMemo } from 'react'
import { Filter } from '@pretamanger/component-library'

import {
  BoxContains,
  LabelVeganOption,
  CircleCounter,
  Counter,
  SideBarFilter
} from './styles'
import { FilterCheckbox, mapListFilter } from '../filter-allergens-modal'
import { useGetTranslation } from '#src/auth/my-account-page/hooks/use-get-translation'
import { useAllergensQuery } from '#src/auth/my-account-page/hooks/use-allergens-query'
import { suitablesList } from '../filter-allergens-modal/const'

export const BoxAllergens = ({ openModal }) => {
  const {
    updateFilterQuery,
    arrAllergens,
    suitables: suitablesQuery
  } = useAllergensQuery()
  const getTranslation = useGetTranslation()
  const text = {
    labelVegan: getTranslation('filter-allergens-label-vegan'),
    labelContains: getTranslation('filter-allergens-contains')
  }
  const lengthAllergens = arrAllergens?.length

  const listsVegan = useMemo(() => {
    return mapListFilter(suitablesList, suitablesQuery)
  }, [suitablesQuery])

  const onChange = (name, eventTarget) => {
    const { checked } = eventTarget
    const action = checked ? 'add' : 'remove'
    updateFilterQuery({
      type: 'suitables',
      name,
      action
    })
  }

  if (lengthAllergens) {
    return (
      <SideBarFilter>
        <FilterCheckbox
          label={text.labelVegan}
          lists={listsVegan}
          isNotHidden
          onChange={onChange}
        />
        <BoxContains isBlack onClick={openModal}>
          <LabelVeganOption isWhite>{text.labelContains}</LabelVeganOption>
          <CircleCounter>
            <Counter data-testid='counter-allergens'>{lengthAllergens}</Counter>
          </CircleCounter>
        </BoxContains>
      </SideBarFilter>
    )
  }

  return (
    <SideBarFilter>
      <FilterCheckbox
        label={text.labelVegan}
        lists={listsVegan}
        isNotHidden
        onChange={onChange}
      />
      <BoxContains onClick={openModal}>
        <LabelVeganOption>{text.labelContains}</LabelVeganOption>
        <Filter color='#372F31' />
      </BoxContains>
    </SideBarFilter>
  )
}
